export default __webpack_public_path__ + "static/trichomoniasis-box@2x-17981fa30d169c9d44c437cbd88061ba.png";